import React from 'react'
import SEO from "../Component/SEO";
import './contact.css'
import Gfooter from '../Component/Gfooter';
import Newform from './Newform';
// import NewForm1 from './NewForm1';


function Contact() {
    return (
        <>

            <SEO
                title="Contact NLF Solutions | Architectural Products in Nagpur"
                description="Contact NLF Solutions in Nagpur for architectural products, facade, ceiling, furniture, roofing, flooring and interior solutions."
                canonical="https://nlfs.in/contact-us"
                keywords="NLF Solutions Nagpur, NLF Solutions contact, Architectural products Nagpur, Architectural solutions Nagpur, Interior solutions Nagpur, architectural products supplier in Nagpur, architectural solutions company in Nagpur, facade solutions in Nagpur"
                schema={{
                    "@context": "https://schema.org",
                    "@type": "LocalBusiness",
                    "name": "NLF Solutions Pvt. Ltd.",
                    "url": "https://nlfs.in/",
                    "image": "https://nlfs.in/Navlogo/NLFLogo.gif",
                    "telephone": "+91-9403964524",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Plot # 6, New Corporation Colony, North Ambajhari Rd",
                        "addressLocality": "Nagpur",
                        "addressRegion": "Maharashtra",
                        "postalCode": "440010",
                        "addressCountry": "IN"
                    }
                }}
            />
            <h1 className="seo-h1">Contact NLF Solutions</h1>

            <Newform />
            {/* <NewForm1/> */}
            {/* <Address/> */}
            <Gfooter />
        </>
    );
}

export default Contact;